import { httpClient } from './core';

export interface LegacyUformMappingDto {
  id: number;
  standort_id: number;
  source_system: string;
  legacy_id: number;
  new_uform_id: number;
  new_uform_name: string | null;
}

export interface LegacyUformDto {
  id: number;
  name: string;
  dauer: number | null;
}

export interface UformOption {
  id: number;
  name: string;
  aktiv: boolean;
}

export interface LegacyUformMappingsResponse {
  standort_id: number;
  mappings: LegacyUformMappingDto[];
  legacy_uforms: LegacyUformDto[];
  uforme: UformOption[];
}

export interface UpsertUformMappingPayload {
  standort_id: number;
  legacy_uform_id: number;
  new_uform_id: number;
}

export interface BulkUformMappingPayload {
  standort_id: number;
  mappings: Array<{
    legacy_uform_id: number;
    new_uform_id: number;
  }>;
}

export interface BulkUformMappingResult {
  written: number;
  skipped: number;
  errors: Array<{ index: number; reason: string; new_uform_id?: number }>;
}

export const legacyUformMappingApi = {
  list: async (standortId: number): Promise<LegacyUformMappingsResponse> => {
    const res = await httpClient<LegacyUformMappingsResponse>(
      `/api/admin/legacy-uform-mappings?standort_id=${encodeURIComponent(String(standortId))}`
    );
    if (res.error || !res.data) throw new Error(res.error || 'Mappings konnten nicht geladen werden');
    return res.data;
  },
  upsert: async (payload: UpsertUformMappingPayload): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/admin/legacy-uform-mappings`, {
      method: 'POST',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
  delete: async (standortId: number, legacyUformId: number): Promise<void> => {
    const res = await httpClient<{ ok: boolean }>(`/api/admin/legacy-uform-mappings`, {
      method: 'DELETE',
      body: JSON.stringify({ standort_id: standortId, legacy_uform_id: legacyUformId }),
    } as RequestInit);
    if (res.error) throw new Error(res.error);
  },
  bulk: async (payload: BulkUformMappingPayload): Promise<BulkUformMappingResult> => {
    const res = await httpClient<BulkUformMappingResult>(`/api/admin/legacy-uform-mappings/bulk`, {
      method: 'POST',
      body: JSON.stringify(payload),
    } as RequestInit);
    if (res.error || !res.data) throw new Error(res.error || 'Bulk-Update fehlgeschlagen');
    return res.data;
  },
};
